/**
 * Filter POS/purchase item grid by category and search text.
 * Category is matched on the root item only (nested objects lack ca_id).
 */
export function filterItemsPosList(items, { ca_id, searchPos }) {
  const categoryId =
    ca_id === "" || ca_id === null || ca_id === undefined
      ? null
      : Number(ca_id);

  const searchValue = (searchPos || "").trim().toLowerCase();

  function matchesSearch(obj) {
    for (const key in obj) {
      const value = obj[key];
      if (value !== null && typeof value === "object") {
        if (matchesSearch(value)) {
          return true;
        }
      } else if (
        value != null &&
        value.toString().toLowerCase().includes(searchValue)
      ) {
        return true;
      }
    }
    return false;
  }

  return items.filter((item) => {
    if (categoryId !== null && Number(item.ca_id) !== categoryId) {
      return false;
    }
    if (!searchValue) {
      return true;
    }
    return matchesSearch(item);
  });
}
